import { h as __h } from "preact";
import { signal } from "@preact/signals";
import { Component } from "preact";
/** @import { RefObject } from "preact"; */

import html from "~/util/html.js";
import { persist } from "~/util/persist.js";
import { boolean, parse } from "~/util/validate.js";
import Button from "~/component/Button.js";
import Modal from "~/component/Modal.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./HelpModal.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./HelpModal.module.css", import.meta.url);
const css = adopt(sheet);
export const promptOnConnection = signal(true);
persist(promptOnConnection, "prompt_on_connection", {
  parse: x => parse(boolean, x)
});

/**
 * @typedef {object} Props
 * @property {boolean} [open]
 * @property {boolean} [displayHideCheckbox]
 * @property {(returnValue: string) => void} [onClose]
 * @property {RefObject<Modal>} [modalRef]
 * @property {string} [returnValue]
 */

/** @extends {Component<Props>} */
export default class HelpModal extends Component {
  render() {
    return __h(Modal, {
      title: "Phaze help",
      ref: this.props.modalRef,
      open: this.props.open,
      onClose: this.props.onClose
    }, __h("p", {}, "To configure client settings, click the Phaze icon (defaults to the top left)."), __h("p", {}, "If you encounter any bugs or have any feature requests,", __h("br", {}), "please ", __h("a", {
      href: "https://phaze-app.typeform.com/to/v65F08l0"
    }, "send us feedback"), ", we'd\n\t\t\t\t\tlove to hear from you!"), __h("p", {}, "For more help, visit ", __h("a", {
      href: "https://help.phaze.app"
    }, "help.phaze.app"), "."), this.props.displayHideCheckbox ? __h("label", {
      "class": css.label
    }, __h("input", {
      type: "checkbox",
      checked: !promptOnConnection.value,
      onInput: (/** @type {Event & { currentTarget: HTMLInputElement }} */e) => {
        promptOnConnection.value = !e.currentTarget.checked;
      }
    }), __h("span", {}, "Don't show this again")) : null, __h("form", {
      "class": css.modalFooter,
      method: "dialog"
    }, __h(Button, {
      level: "primary",
      type: "submit",
      value: this.props.returnValue
    }, "Okay")));
  }
}